import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { CgCPlusPlus } from 'react-icons/cg';
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiGit,
  DiJava,
  DiPhp,
  DiMysql,
} from 'react-icons/di';
import { SiRedux, SiTailwindcss, SiTypescript } from 'react-icons/si';

function Techstack() {
  return (
    <Row style={{ justifyContent: 'center', paddingBottom: '50px' }}>
      <Col xs={4} md={2} className='tech-icons'>
        <DiJava />
      </Col>
      {/* <Col xs={4} md={2} className='tech-icons'>
        <DiHtml5 />
      </Col>
      <Col xs={4} md={2} className='tech-icons'>
        <DiCss3Full />
      </Col> */}
      <Col xs={4} md={2} className='tech-icons'>
        <DiJavascript1 />
      </Col>
      <Col xs={4} md={2} className='tech-icons'>
        <SiTypescript />
      </Col>
      <Col xs={4} md={2} className='tech-icons'>
        <DiNodejs />
      </Col>
      <Col xs={4} md={2} className='tech-icons'>
        <DiReact />
      </Col>
      <Col xs={4} md={2} className='tech-icons'>
        <SiRedux />
      </Col>

      <Col xs={4} md={2} className='tech-icons'>
        <DiMysql />
      </Col>
      <Col xs={4} md={2} className='tech-icons'>
        <DiMongodb />
      </Col>

      <Col xs={4} md={2} className='tech-icons'>
        <SiTailwindcss />
      </Col>

      <Col xs={4} md={2} className='tech-icons'>
        <DiPhp />
      </Col>

      <Col xs={4} md={2} className='tech-icons'>
        <DiGit />
      </Col>
      <Col xs={4} md={2} className='tech-icons'>
        <DiPython />
      </Col>
      <Col xs={4} md={2} className='tech-icons'>
        <CgCPlusPlus />
      </Col>
    </Row>
  );
}

export default Techstack;
